<div class="header">
  <div class="title">Change Layout</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>
<!-- Model only have dropdown there fore keydown event is binded -->
<form [formGroup]="projectForm">
  <!-- Subject -->
  <div class="flex flex-col gt-xs:flex-row mt-3">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Layout</mat-label>
      <mat-select [formControlName]="'template_id'">
        <mat-option *ngFor="let projectTemplate of projectTemplates" [value]="projectTemplate.id">
          {{ projectTemplate.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Body -->

  <div class="actions">
    <div class="formatting"></div>

    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button (click)="discard()">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        #btnFocus="matButton"
        [autofocus]="btnFocus.focus()"
        [disabled]="projectForm.invalid"
        (click)="save()"
      >
        <span *ngIf="!projectForm.disabled">Save</span>
        <mat-progress-spinner
          *ngIf="projectForm.disabled"
          [diameter]="24"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </button>
    </div>
  </div>
</form>
